import React, { useEffect } from 'react';
import { useTitle } from "../../../contexts/title";
import { questionsAndAnswers } from './questions-and-answers';
import FAQList from '../../../features/common/faq/components/FAQList';
import { useAuth } from '../../../contexts/auth';
import { useGetCompany } from '../../../api/company';


export default function FAQsPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('FAQs')
	}, [pageTitle]);

	const { user } = useAuth();
	const company = useGetCompany(user?.companyId);
	const integrationWithIME = !!company.data?.assignedRetailers.find(x => x.IME);
	const faqListData = questionsAndAnswers.filter(x => !x.IMEOnly || integrationWithIME)

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<div className='dx-card wide-card'>
					<FAQList questionsAndAnswers={faqListData} />
				</div>
			</div>
		</React.Fragment>
	)
} 
